function setOrders(data) {
	return {
		type: 'SET_ORDERS',
		payload: data,
	};
}

export { setOrders };
